import styled from 'styled-components';
import { Row } from 'antd';

export const Container = styled(Row)`
  display: flex;
  flex-wrap: wrap;
`;
